<template>
  <div class="t-background-white">
    <div class="o-width-limiter">
      <div
        class="c-buffer-box c-buffer-box--no-top c-buffer-box--tight-bottom d-print-none"
      >
        <router-link to="/">Tillbaka till alla processer</router-link>
        <img
          v-if="appCustomerLogotype"
          class="customer-image t-margin-bottom-s"
          v-bind:src="appCustomerLogotype"
          alt=""
          width="200"
          height="50"
        />
      </div>
      <div class="o-grid">
        <div class="o-grid__column t-hidden@below-md" data-size="md:3">
          <process-steps-data-provider
            v-if="id !== '0'"
            :process-id="currentId"
          >
            <div slot-scope="dataProvider">
              <process-step-summary
                :process-name="dataProvider.processName"
                :process-steps="dataProvider.processSteps"
              ></process-step-summary>
            </div>
          </process-steps-data-provider>
        </div>
        <div
          id="content-primary"
          class="o-grid__column o-grid__column--block t-position-relative"
          data-size="below-md:12 md:9"
        >
          <process-data-provider
            ref="refDataProvider"
            :process-id="id"
            :original-id="originalId"
            :category="category"
          >
            <div slot-scope="dataProvider">
              <template v-if="dataProvider.hasChangelogReminder">
                <div
                  class="c-message c-message--inline c-message--narrow t-margin-bottom-m"
                >
                  <div class="c-message__inner">
                    <div class="c-message__text">
                      <p>Ändringshistorik</p>
                      <p class="c-message__body-text">
                        Kom ihåg att lägga till en kommentar i
                        ändringshistoriken vid ändringar.
                      </p>
                    </div>
                    <button
                      class="c-button c-button--reset c-message__close"
                      title="Stäng"
                      @click="
                        dataProvider.removeProcessIdRemindChangelog({ id: id })
                      "
                    >
                      <vue-icon name="close"></vue-icon>
                      <span class="t-visually-hidden">Stäng</span>
                    </button>
                  </div>
                </div>
              </template>
              <template v-if="dataProvider.error > 0">
                <h1 class="t-text-style-alpha">Processen kunde inte hittas</h1>
                <p class="t-margin-top-s">
                  Det finns inte någon process med id
                  <span class="t-style-italic">{{ id }}</span
                  >, eller så saknar du behörighet att se den.
                </p>
              </template>
              <template v-if="dataProvider.error === 0">
                <div v-if="dataProvider.loading" class="c-spinner"></div>
                <vue-tabs
                  :show="
                    $can('customize', 'ProcessTemplate') &&
                      dataProvider.originalProcess &&
                      Object.keys(dataProvider.originalProcess).length > 0
                  "
                  :process="dataProvider.process"
                  @open="openChangeLog"
                  @markasread="markRead"
                  @tabSwitched="
                    tabSwitched($event);
                    dataProvider.tabSwitched($event);
                  "
                >
                  <template slot="Process">
                    <process-item
                      :mode="dataProvider.mode"
                      v-bind="dataProvider.process"
                      @edit="dataProvider.edit"
                      @create="dataProvider.create"
                      :error="dataProvider.error"
                      :category="dataProvider.category"
                      @publish="dataProvider.publish"
                      @unpublish="dataProvider.unpublish"
                      @customize="dataProvider.customize"
                      @delete="dataProvider.delete"
                    >
                    </process-item>
                  </template>
                  <template slot="Processmall">
                    <process-item
                      mode="view"
                      v-bind="dataProvider.originalProcess"
                      @edit="dataProvider.edit"
                      :error="dataProvider.error"
                      :expandChangeLogFromStart="
                        dataProvider.process &&
                          dataProvider.process.notifications &&
                          dataProvider.process.notifications.length > 0
                      "
                      :showConsentButton="
                        dataProvider.process &&
                          dataProvider.process.notifications &&
                          dataProvider.process.notifications.length > 0
                      "
                      @customize="dataProvider.customize"
                      @logReadConsent="logReadConsent"
                    >
                    </process-item>
                  </template>
                  <template slot="notify">
                    <notify-pill
                      v-if="
                        dataProvider.process &&
                          dataProvider.process.notifications &&
                          dataProvider.process.notifications.length > 0
                      "
                      :notifications="dataProvider.process.notifications"
                    ></notify-pill>
                  </template>
                </vue-tabs>
              </template>
            </div>
          </process-data-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProcessStepsDataProvider from './../process-steps-data-provider/ProcessStepsDataProvider.vue';
import ProcessDataProvider from './../process-data-provider/ProcessDataProvider.vue';
import ProcessItem from './../process-item/ProcessItem.vue';
import VueTabs from '@/components/vue-components/vue-tabs/VueTabs.vue';
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
import ProcessStepSummary from './../process-step-summary/ProcessStepSummary.vue';
import NotifyPill from '@/components/vue-components/notify-pill/NotifyPill.vue';

export default {
  name: 'ProcessPage',
  components: {
    ProcessDataProvider,
    ProcessItem,
    VueTabs,
    VueIcon,
    ProcessStepsDataProvider,
    ProcessStepSummary,
    NotifyPill
  },
  props: {
    id: {
      type: String,
      default: '0'
    },
    category: {
      type: String,
      default: '0'
    },
    apiUrl: {
      type: String,
      default: ''
    },
    companyId: {
      type: String,
      default: ''
    },
    appCustomerLogotype: {
      type: String,
      default: ''
    }
  },
  computed: mapGetters('processes', {
    process: 'process'
  }),
  data() {
    return {
      currentId: this.id
    };
  },
  methods: {
    tabSwitched(tab) {
      if (tab === 'Processmall') {
        this.currentId = this.process(this.id).originalProcess.toLowerCase(); // TODO lowercase?
      } else {
        this.currentId = this.id;
      }
    },
    logReadConsent() {
      this.$refs.refDataProvider.logReadConsent();
    }
  },
  created() {
    this.$store.dispatch('processes/setAppData', {
      apiUrl: this.apiUrl,
      companyId: this.companyId
    });
  }
};
</script>
